// KPI Builder — what hand-written JSON can add to any KPI: a backend handler, dashboard filters and extra settings.
import { BuilderConfig, ExtraAnswers, ExtraFilter, ExtraSetting, QueryObject } from './types';

/** Written by the builder itself so a KPI can be reopened; never overwritten by a typed setting. */
const RESERVED = ['builder'];

/** A number, true/false, a list or an object when the text is valid JSON; otherwise the text as typed. */
export const parseSettingValue = (value: string): unknown => {
  try {
    return JSON.parse(value.trim());
  } catch {
    return value;
  }
};

export const usableSettings = (e: ExtraAnswers): ExtraSetting[] => e.settings.filter((s) => s.key.trim() !== '' && !RESERVED.includes(s.key.trim()));
export const usableFilters = (e: ExtraAnswers): ExtraFilter[] => e.filters.filter((f) => f.key.trim() !== '' && f.field.trim() !== '');

const appliesTo = (f: ExtraFilter, index: number): boolean => f.on.trim() === '' || Number(f.on) === index + 1;

export interface Extended { queries: QueryObject[]; config: BuilderConfig; handlerKey?: string; }

/** Add the typed handler, dashboard filters and settings to what a question generated. */
export function applyExtras(queries: QueryObject[], config: BuilderConfig, handlerKey: string | undefined, e: ExtraAnswers): Extended {
  const filters = usableFilters(e);
  const extended = queries.map((q, i) => ({
    ...q,
    requestQueryMap: { ...q.requestQueryMap, ...Object.fromEntries(filters.filter((f) => appliesTo(f, i)).map((f) => [f.key.trim(), f.field.trim()])) },
  }));
  const settings = Object.fromEntries(usableSettings(e).map((s) => [s.key.trim(), parseSettingValue(s.value)]));
  return { queries: extended, config: { ...config, ...settings }, handlerKey: e.handlerKey.trim() || handlerKey };
}
